import { Placeholder } from "react-bootstrap";

export function TablePlaceholder() {
  return (
    <>
      <tr>
        <td className="text-wrap">
          <Placeholder animation="wave" className="w-100">
            <Placeholder xs={8} bg="secondary" />
          </Placeholder>
        </td>
        <td>
          <Placeholder animation="wave">
            <Placeholder.Button xs={3} size="sm" className="btn btn-secondary" outline="true" />
          </Placeholder>
        </td>
      </tr>
      <tr>
        <td className="text-wrap">
          <Placeholder animation="wave" className="w-100">
            <Placeholder xs={7} bg="secondary" />
          </Placeholder>
        </td>
        <td>
          <Placeholder animation="wave">
            <Placeholder.Button xs={3} size="sm" className="btn btn-secondary" outline="true" />
          </Placeholder>
        </td>
      </tr>
      <tr>
        <td className="text-wrap">
          <Placeholder animation="wave" className="w-100">
            <Placeholder xs={9} bg="secondary" />
          </Placeholder>
        </td>
        <td>
          <Placeholder animation="wave">
            <Placeholder.Button xs={3} size="sm" className="btn btn-secondary" outline="true" />
          </Placeholder>
        </td>
      </tr>
    </>
  );
}
